import { render } from "./LoadingModal.vue?vue&type=template&id=016a40dc"
import script from "./LoadingModal.vue?vue&type=script&lang=js"
export * from "./LoadingModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rapid-rent/rug-doctor-home-delivery/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__